import styled from 'styled-components';
import { cyrillicFonts } from '@libs/theme';
import SelectModal from '../select/select-modal/SelectModal';
import { SelectOption } from '../select/select-modal/SelectModalOption';
export const CustomSelectModal = styled(SelectModal) `
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 4rem;
  max-width: 9.4rem;
  border-radius: 5.6rem;

  position: relative;
  padding: 1.4rem 1.4rem;

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  color: ${({ theme }) => theme.colors.text.default};

  .select-icon {
    margin-right: 0.4rem;
  }

  .select-dropdown-icon {
    padding: 0 0.6rem;
  }

  .valueWrapper {
    height: fit-content;
  }
  .select-modal-options {
    top: calc(100% + 0.8rem);
  }
  ${({ theme }) => theme.media.tablet `
   .select-modal-options {
    width:9.9rem;
  }
    height: 4.8rem;
    max-width: 10.5rem;
  `}
`;
export const CustomSelectOption = styled(SelectOption) `
  ${({ theme, isCyrillic }) => theme.media.tablet `
    padding: 0;
    justify-content: center;
    align-items: center;
    height: 4.3rem;
    .radio-button {
      display: none;
    }
    .radio-text {
      margin-left: 0.5rem;
      margin-right: 0;
    }
  
    .radio-icon {
      width: auto;
    }

    .radio-title {
      ${(isCyrillic
    ? 'font-family: ' + cyrillicFonts.primaryMedium
    : '')}
    }
  `}
`;
export const CustomSelectOptionWrapper = styled.li `
  width: 100%;

  && {
    ${({ theme, selectedOptionCheck }) => theme.media.tablet `
    margin: 0;
    display: ${(!selectedOptionCheck
    ? 'none'
    : 'auto')};
    `}
  }
`;
export const ListContainer = styled.div `
  margin: 1.6rem;

  ${({ theme }) => theme.media.tablet `
      margin: unset;
  `}
`;
//# sourceMappingURL=styles.js.map